import { FocusMonitor } from '@angular/cdk/a11y'
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
} from '@angular/core'

import { RippleDirective } from '../ripple/ripple.directive'

export type ButtonAppearance = 'primary' | 'secondary'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'a[pai-button], button[pai-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RippleDirective],
  host: {
    class: 'pai-button',
    '[class.pai-button--primary]': `this.appearance === 'primary'`,
    '[class.pai-button--secondary]': `this.appearance === 'secondary'`,
    '[class.pai-button--loading]': `this.isLoading`,
    '[style.--button-min-width]': `this.minWidth`,
    '[attr.disabled]': 'this.disabledAttr',
  },
})
export class ButtonComponent implements OnDestroy {
  @Input() appearance: ButtonAppearance = 'primary'
  @Input() disabled = false
  @Input() minWidth: `${number}${'px' | 'mm' | 'em' | '%'}` | null = null
  @Input() isLoading = false

  protected get disabledAttr(): 'disabled' | null {
    return this.disabled || this.isLoading ? 'disabled' : null
  }

  readonly elementRef = inject<ElementRef<HTMLButtonElement | HTMLAnchorElement>>(ElementRef)
  private readonly focusMonitor = inject(FocusMonitor)

  constructor() {
    afterNextRender(() => this.focusMonitor.monitor(this.elementRef))
  }

  ngOnDestroy() {
    this.focusMonitor.stopMonitoring(this.elementRef)
  }
}
